module.exports = __webpack_public_path__ + "static/media/Kosovo.54cc5b12.png";